import {
  CREATE_CATALOGITEM_NEW_RECORD,
  CREATE_CATALOGITEM_NEW_RECORD_SUCCESS,
  CREATE_CATALOGITEM_NEW_RECORD_ERROR,

  GET_CATALOGITEM_NEW_RECORD,
  GET_CATALOGITEM_NEW_RECORD_SUCCESS,
  GET_CATALOGITEM_NEW_RECORD_ERROR,

  UPDATE_CATALOGITEM_NEW_RECORD,
  UPDATE_CATALOGITEM_NEW_RECORD_SUCCESS,
  UPDATE_CATALOGITEM_NEW_RECORD_ERROR,

  GET_CATALOGITEM_TERMS,
  GET_CATALOGITEM_TERMS_SUCCESS,
  GET_CATALOGITEM_TERMS_ERROR,

  SET_RECORD_TYPE,
  UPDATE_NEW_RECORD_STATE,
} from "../actions";
import EnumRecordTypes from "../../enums/enumRecordTypes";

const INIT_STATE = {
  isNewRecordPanelShown: false,
  isNewCommentPanelShown: false,
  recordTypeSelected: EnumRecordTypes.Person,
  loading: false,
  error: "",
  record: {},
  catalogItemRecord: {},
  catalogItemId: null,
  terms:[]
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_CATALOGITEM_TERMS:
      return { ...state, loading: true, error: "", terms: action.payload.terms };
    case GET_CATALOGITEM_TERMS_SUCCESS:
      return { ...state, loading: false, error: "", terms: action.payload };
    case GET_CATALOGITEM_TERMS_ERROR:
       return { ...state, loading: false, error: action.payload.message };
    case CREATE_CATALOGITEM_NEW_RECORD:
      return { ...state, loading: true, error: "", record: action.payload.newRecord };
    case CREATE_CATALOGITEM_NEW_RECORD_SUCCESS:
      return { ...state, loading: false, error: "", record: action.payload, isNewRecordPanelShown: false };
    case CREATE_CATALOGITEM_NEW_RECORD_ERROR:
      return { ...state, loading: false, error: action.payload.message };
    case GET_CATALOGITEM_NEW_RECORD:
      return { ...state, loading: true, error: "", catalogItemId: action.payload.catalogItemId };
    case GET_CATALOGITEM_NEW_RECORD_SUCCESS:
      return { ...state, loading: false, error: "", catalogItemRecord: action.payload, isNewRecordPanelShown: false };
    case GET_CATALOGITEM_NEW_RECORD_ERROR:
      return { ...state, loading: false, error: action.payload.message };
    case UPDATE_CATALOGITEM_NEW_RECORD:
      return { ...state, loading: true, error: "", catalogItemId: action.payload.catalogItemId };
    case UPDATE_CATALOGITEM_NEW_RECORD_SUCCESS:
      return { ...state, loading: false, error: "", catalogItemRecord: action.payload, isNewRecordPanelShown: false };
    case UPDATE_CATALOGITEM_NEW_RECORD_ERROR:
      return { ...state, loading: false, error: action.payload.message };      
    case SET_RECORD_TYPE:
      return { ...state, recordTypeSelected: action.payload.recordTypeSelected };
    case UPDATE_NEW_RECORD_STATE:
      return { ...state, ...action.payload.updatedValues }
    default:
      return { ...state };
  }
};
